import { Component, EventEmitter, Input, Output } from "@angular/core";
import { NavTabModel } from "src/app/core/nav-storage/model/nav-tab.dto";


@Component({
    selector:'app-top-navbar-tab',
    templateUrl:'./top-navbar-tab.component.html',
    styleUrls: ['./top-navbar-tab.component.scss']
})
export class TopNavbarTabComponent{

    @Input() navTab: NavTabModel;
    @Output() closeTab = new EventEmitter();

    public close(){
        this.closeTab.emit(this.navTab);
    }
}


